import _ from 'lodash'
import Qs from 'qs'
import axios from 'axios'

let geoCoords

const options = {
  enableHighAccuracy: true
}

function success (pos) {
  geoCoords = pos.coords
}

function failed (err) {
  window.sessionStorage.setItem('getPosStatus', err)
}

function startToWatchGps () {
  if (window.sessionStorage.getItem('watcherTimeID') !== null) {
    clearInterval(parseInt(window.sessionStorage.getItem('watcherTimeID')))
    window.sessionStorage.removeItem('watcherTimeID')
  }
  const timeoutID = navigator.geolocation.watchPosition(success, failed, options)
  window.sessionStorage.setItem('watcherTimeID', timeoutID)
}

function getGeoCoords () {
  return geoCoords
}

function sendGeoLocation (prjId, qrcode, page) {
  if (!_.isEmpty(prjId) && !_.isEmpty(qrcode) && window.sessionStorage.getItem('watcherTimeID') !== null) {
    const { latitude, longitude } = getGeoCoords()
    // console.info(`Time : ${new Date().toString()}`)
    // console.info(`prjId : ${prjId}`)
    // console.info(`qrcode: ${qrcode}`)
    // console.info(`Latitude : ${latitude}`)
    // console.info(`Longitude: ${longitude}`)
    // console.info(`userAgent: ${navigator.userAgent}`)
    const trxDetail = {
      page: page,
      deviceFingerPrint: window.localStorage.getItem('deviceFingerPrint'),
      latitude: latitude,
      longitude: longitude,
      deviceInfo: navigator.userAgent
    }
    const data = { qr_id: qrcode,
      projectCode: prjId,
      trx_detail: JSON.stringify(trxDetail)
    }
    const config = {
      headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
      }
    }
    axios.post('https://api.y2services.com/v1/guideqrinfo/add', Qs.stringify(data), config)
      .then((response) => {
      })
      .catch((e) => {
      })
  }
}

function askGPS () {
  if ('geolocation' in navigator) {
    /* geolocation is available */
    navigator.geolocation.getCurrentPosition((position) => {
      return position
    }, this.handleGPSError, { timeout: 60000 })
  } else {
    alert('loginPage.GPSBrowserFailed')
  }
}

function handleGPSError (error) {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      alert('您沒有授權取得定位資訊，請至系統設定中開啟')
      break
    case error.POSITION_UNAVAILABLE:
      alert('目前您所在的位置無法取得定位資訊')
      break
    case error.TIMEOUT:
      alert('定位超過 60 秒，系統會繼續進行定位')
      break
    default:
      alert('裝置發生錯誤，無法取得您的定位資訊')
  }
}

export { startToWatchGps, getGeoCoords, sendGeoLocation, askGPS, handleGPSError }
